export const openLinkInNewTab = (url: string) => {
  const newTab = window.open(url, '_blank');
  if (!newTab) return;
  newTab.focus();
};

export const getExploreUrlFromQueryUrl = (url: string) => {
  const urlObj = new URL(url);
  const pathParts = urlObj.pathname.split('/');

  if (pathParts.length > 1) {
    pathParts[1] = 'explore';
  }

  urlObj.pathname = pathParts.join('/');

  return urlObj.toString();
};
